<template>
  <div class="event-card">
    <div class="media">
      <img :src="event.media" />
    </div>
    <div class="pa-4 d-flex align-center">
      <div>
        <div class="d-flex align-center" style="width:100%">
          <h4 class="ma-0">{{ event.title }}</h4>
          <v-btn icon color="red" class="ml-auto"><i class="fa fa-trash"></i></v-btn>
        </div>
        <small class="font-weight-bold d-block">
          <v-chip-group>
            <v-chip v-for="genre of event.genre" x-small :key="genre">
              {{ genre }}
            </v-chip>
          </v-chip-group>
        </small>
        <small>{{ event.description }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserCard",
  props: ["event"],
};
</script>

<style scoped>
.event-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.media {
  width: 100%;
  height: 150px;
  background: rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.media img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
</style>